import axios from "axios";
import { API_URL } from "../enviroment";
import { getToken } from "../service/firebase";

export async function CreateInvoices(data: any) {
  const res = await axios({
    method: 'post',
    url: `${API_URL}/invoice`,
    headers: {
      'Authorization': 'Bearer ' + await getToken(),
    },
    data: data,
  });
  return res.data;
}

export async function GetInvoices(id: string) {
  const res = await axios({
    method: 'get',
    url: `${API_URL}/invoice/project/${id}`,
    headers: {
      'Authorization': 'Bearer ' + await getToken(),
    }
  });
  return res.data;
}

export async function DeleteInvoices(id: number) {
  const res = await axios({
    method: 'delete',
    url: `${API_URL}/invoice/${id}`,
    headers: {
      'Authorization': 'Bearer ' + await getToken(),
    }
  });
  return res.data;
}

export async function GetInvoiceStatuses() {
  const res = await axios({
    method: 'get',
    url: `${API_URL}/invoice-status`,
    headers: {
      'Authorization': 'Bearer ' + await getToken(),
    }
  });
  return res.data;
}

export async function UpdateInvoice(id: any, data: any) {
  const res = await axios({
    method: 'patch',
    url: `${API_URL}/invoice/${id}`,
    headers: {
      'Authorization': 'Bearer ' + await getToken(),
    },
    data: data
  });
  return res.data;
}